<template>
  <div class="deposits">
    <div class="filter-container">
      <span class="transTime">{{ $t('components.date') }}:</span>
      <!-- 转账时间 -->
      <el-date-picker
        v-model="search.times"
        size="small"
        class="mb-10 picker"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd"
        type="daterange"
        range-separator="~"
        :start-placeholder="$t('components.start_date')"
        :end-placeholder="$t('components.end_date')"
      />
      <!--流水号  -->
      <el-input v-model="search.deposit_no" size="small" type="text" placeholder="ID" class="search-frame mb-10" clearable />
      <!--关联商户  -->
      <el-select v-model="search.merchant_no" class="search-frame mb-10" size="small" :placeholder="$t('data.related_merchants')" clearable>
        <el-option
          v-for="(item,index) in relatedMerchantsList"
          :key="index"
          :label="item.merchant_no + '-' + item.merchant_name"
          :value="item.merchant_no"
        />
      </el-select>
      <!-- 查询 -->
      <el-button class="search-btn mb-10" type="primary" size="small" icon="el-icon-search" @click="onClickSearchBtn">{{ $t('components.search') }}</el-button>
    </div>
    <div class="tableContainer">
      <!-- 列表 -->
      <el-table
        v-loading="listLoading"
        :data="tableData"
        stripe
        fit
        highlight-current-row
        style="width: 100%"
        class="tableContainer"
      >
        <el-table-column label="ID" align="center">
          <template slot-scope="scope">
            {{ scope.row.deposit_no }}
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.amount')" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.trans_type === Credit">-{{ scope.row.amount | toDivideWithDot }}</span>
            <span v-if="scope.row.trans_type === Debit">+{{ scope.row.amount | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.action_type')" align="center">
          <template slot-scope="scope">
            {{ getActionTypeChangeLabel(scope.row.trans_type) }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('data.associated_merchant_id')" align="center">
          <template slot-scope="scope">
            {{ scope.row.relate_merchant_no }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('data.associated_merchant_name')" align="center">
          <template slot-scope="scope">
            {{ scope.row.relate_merchant_name }}
          </template>
        </el-table-column>
        <!--
        <el-table-column :label="$t('data.transfer_out_merchant_no')" align="center">
          <template slot-scope="scope">
            {{ scope.row.origin_merchant && scope.row.origin_merchant.merchant_no }}
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.transfer_in_merchant_no')" align="center">
          <template slot-scope="scope">
            {{ scope.row.merchant && scope.row.merchant.merchant_no }}
          </template>
        </el-table-column> -->

        <el-table-column :label="$t('data.transfer_time')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.create_time }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.remark')" align="center">
          <template slot-scope="scope">
            {{ scope.row.remark }}
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <paginator v-if="!listLoading" :list-query="listQuery" @paginator-change="onClickPaginator" />
      </div>
    </div>

  </div>
</template>

<script>

import { fetchMchtransferList } from '@/api/settlement/settlement'
import { fetchRelateMchsList } from '@/api/merchant-manage/merchant-manage.js'
import { rechargeStatusMap, actionTypeChange } from '@/utils/maps'
import { filterEmptyAttr } from '@/utils/common'
import { appointDate } from '@/utils/index.js'

export default {
  name: 'Deposits',
  components: {
    Paginator: () => import('@/views/components/Paginator')
  },
  data() {
    this.Credit = 1
    this.Debit = 2
    this.curMerchant_id = this.$store.getters.userInfo && this.$store.getters.userInfo.merchant_id
    return {
      search: {
        merchant_id: null, // 交易状态
        times: [appointDate(-3), appointDate()]
      },
      rechargeStatusArr: rechargeStatusMap(),
      tableData: [],
      relatedMerchantsList: [],
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 15,
        total: 0
      }
    }
  },
  computed: {
    getActionTypeChangeLabel() {
      return function(trans_type) {
        return actionTypeChange(trans_type).label
      }
    },
    getRechargeStatusStyle() {
      return function(value) {
        return rechargeStatusMap(value).type
      }
    }

  },

  created() {
    this.getMchRechargeInfo()
    this.getMchTransferList()
  },
  methods: {
    getMchRechargeInfo(otherParams) {
      const params = this.getParams(otherParams)
      this.listLoading = true
      fetchMchtransferList(params).then(res => {
        const { total, list = [] } = res.data
        this.listQuery.total = total
        this.listQuery.page = params.page ? params.page : 1
        this.tableData = list
      }).finally(() => {
        this.listLoading = false
      })
    },
    getMchTransferList() {
      fetchRelateMchsList().then(res => {
        this.relatedMerchantsList = res.data
      })
    },
    getParams(otherParams = {}) {
      const { times = [], ...searchParams } = this.search
      let params = { start_date: times && times[0], end_date: times && times[1], ...searchParams, ...otherParams }
      params = filterEmptyAttr(params)
      return params
    },

    onClickPaginator() {
      this.getMchRechargeInfo(this.listQuery)
    },
    onClickSearchBtn() {
      this.getMchRechargeInfo()
    }
  }
}
</script>

<style lang="scss" scoped>
.deposits{
   .transTime{
    display: inline-block;
    padding: 0 20px 10px 0;
    font-size: 14px;
    font-weight: 500;  font-family: 'Inter-Medium';

  }
  .filter-container{
    margin-top: 14px;
    margin-bottom: 32px;
    text-align: right;
  }
  .search-frame {
    width: 250px;
    margin-right: 5px;
  }
  .search-btn {
    margin-right: 10px;
  }
  .picker{
    width: 230px;
    margin-right: 5px;
  }
  .download-btn{
    margin: 0;
  }
 .mb-10{
    margin-bottom: 10px;
  }
}

</style>
